/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ApplicationProcessingErrorReasonDto {
    INVALID_ADDRESS = 'INVALID_ADDRESS',
    DUPLICATED = 'DUPLICATED',
    DUPLICATED_COMMUNICATION_FAILURE = 'DUPLICATED_COMMUNICATION_FAILURE',
    CREDIT_INSTITUTION = 'CREDIT_INSTITUTION',
    CREDIT_INSTITUTION_SEARCH_FAILED = 'CREDIT_INSTITUTION_SEARCH_FAILED',
    CREDIT_INSTITUTION_TECHNICAL_ERROR = 'CREDIT_INSTITUTION_TECHNICAL_ERROR',
    CREATE_CONTRACT_FAILURE = 'CREATE_CONTRACT_FAILURE',
}
